import { useRef, useState } from "react"
import { Dayjs } from "dayjs"
import styled from "styled-components"

import { UITypes } from "types"

import DateRangePicker from "modals/StatsReportModal/DateRangePicker"
import { dropDownOptions } from "modals/StatsReportModal/getMonitoringDateRangeParams"

import { SelectStatic } from "./form/SelectStatic"

const Container = styled.div`
  > div {
    margin-bottom: 5px;
  }

  .static-select__control {
    min-width: 160px;
    width: auto;
    display: flex;
    min-height: 32px !important;
    font-size: 14px;
    cursor: pointer;
  }
`

const CustomDateRangeContainer = styled.div`
  padding: 0 0 0 10px;
`

interface DateRangeSelectProps {
  options?: UITypes.Option[]
  selectedTime: UITypes.Option[]
  selectedDateRange?: [Dayjs, Dayjs] | null
  skipTimeOptions?: boolean
  isMobile?: boolean
  setSelectedDateRange?: (dateRange: [Dayjs, Dayjs] | null) => void
  setSelectedTime: (time: UITypes.Option[]) => void
}

const DateRangeSelect = ({
  options,
  selectedTime,
  selectedDateRange,
  skipTimeOptions,
  isMobile,
  setSelectedDateRange,
  setSelectedTime,
}: DateRangeSelectProps) => {
  const selectKey = useRef(1)
  const isCustom = selectedTime[0].value === "custom"
  const [showCustomDatePicker, setShowCustomDatePicker] = useState(false)
  const selectOptions = options || dropDownOptions

  const handleDateCancel = () => {
    selectKey.current += 1
    setShowCustomDatePicker(false)
  }

  const contentRenderer = () => {
    if (isCustom && selectedDateRange) {
      return () => (
        <CustomDateRangeContainer>
          {selectedDateRange[0].format("MMM D, YYYY")}-{selectedDateRange[1].format("MMM D, YYYY")}
        </CustomDateRangeContainer>
      )
    }

    return undefined
  }

  const handleDateRangeSubmit = (dateRange: [Dayjs, Dayjs]) => {
    setSelectedDateRange?.(dateRange)
    setShowCustomDatePicker(false)
    setSelectedTime([selectOptions[selectOptions.length - 1]])
  }

  const handleSetSelectedTime = (option: UITypes.Option[]) => {
    if (option[0].value === "custom") {
      setShowCustomDatePicker(true)
      return
    }

    setShowCustomDatePicker(false)
    setSelectedTime(option)
  }

  return (
    <Container>
      <SelectStatic
        key={selectKey.current}
        values={selectedTime}
        onChange={handleSetSelectedTime}
        options={selectOptions.filter(
          option => !skipTimeOptions || !["lastHour", "last6Hours", "last24Hours"].includes(String(option.value)),
        )}
        contentRenderer={contentRenderer()}
        isSearchable={false}
      />
      {showCustomDatePicker && (
        <DateRangePicker
          maxRange={30}
          onCancel={handleDateCancel}
          onSubmit={handleDateRangeSubmit}
          selectedRange={selectedDateRange || undefined}
          isMobile={isMobile}
        />
      )}
    </Container>
  )
}

export default DateRangeSelect
